import React from "react";
import { Table, Dropdown, Button, Tooltip } from "antd";
import { MoreOutlined } from "@ant-design/icons";

const ReusableTable = ({
  columns,
  data,
  loading,
  actionItems,
  paginationConfig,
  handleTableChange,
  useFixedHeight = false,
}) => {
  const defaultPaginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    ...paginationConfig,
  };

  const updatedColumns = columns.map((col) => {
    if (col.dataIndex === "url_en" || col.dataIndex === "book_cover_en") {
      return {
        ...col,
        render: (text) =>
          text ? (
            <Tooltip
              title={
                <div onContextMenu={(e) => e.preventDefault()}>
                  <img
                    src={`${process.env.REACT_APP_API_IMG_URI}/${text}`}
                    alt="Preview"
                    className="preview-image"
                  />
                </div>
              }
            >
              <div onContextMenu={(e) => e.preventDefault()}>
                <img
                  src={`${process.env.REACT_APP_API_IMG_URI}/${text}`}
                  alt="Thumbnail"
                  className="thumbnail-image"
                />
              </div>
            </Tooltip>
          ) : (
            "No Image"
          ),
      };
    }
    return col;
  });

  const actionColumn =
    typeof actionItems === "function"
      ? {
          title: "Actions",
          key: "actions",
          fixed: "right",
          width: 80,
          render: (record) => {
            const actions = actionItems(record);
            return (
              <div className="tableDropdown">
                <Dropdown
                  menu={{
                    items: actions.map((item) => ({
                      key: item.key,
                      label: item.label,
                      onClick: () => item.onClick(record),
                    })),
                  }}
                  trigger={["click"]}
                >
                  <Button shape="circle" icon={<MoreOutlined />} />
                </Dropdown>
              </div>
            );
          },
        }
      : null;

  const dataSource = data?.map((item) => ({
    key: item.id,
    ...item,
  }));

  return (
    <div className="commonTable">
      <Table
        columns={
          actionColumn ? [...updatedColumns, actionColumn] : updatedColumns
        }
        dataSource={dataSource}
        loading={loading}
        onChange={handleTableChange}
        pagination={
          paginationConfig === false ? false : defaultPaginationConfig
        }
        scroll={
          useFixedHeight ? { x: "max-content" } : { x: "max-content", y: 500 }
        }
        sticky
      />
    </div>
  );
};

export default ReusableTable;
